import moment from 'moment-timezone'

export function useFormat() {
  const formatMoney = (value) => {
    if (!value) return 0
    return parseFloat(value.replaceAll('.', '').replaceAll(',', '.'))
  }

  const formatNumber = (number) => {
    return `${number.toFixed(2).toString().replace('.', ',')}`
  }

  const formatMoneyS = (value) => {
    if (!value) return 'R$ 0,00'
    return parseFloat(value).toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }

  const formatDate = (date) => {
    if (!date || date == '0000-00-00 00:00:00') return null
    return moment(date).format('DD/MM/YYYY')
  }

  const formatUtcDate = (date) => {
    if (!date || date == '0000-00-00 00:00:00') return null
    return moment(date).utc().format('DD/MM/YYYY')
  }

  const formatMonth = (date) => {
    if (!date || date === '0000-00-00 00:00:00') return ''
    return moment(date).format('MM/YYYY')
  }

  const formatFullDate = (date) => {
    if (!date) return ''
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  const formatFullDateGMT = (date) => {
    if (!date) return ''
    return moment(date).subtract('3', 'hours').format('DD/MM/YYYY HH:mm')
  }

  const formatIsoDate = (date) => {
    if (!date) return ''
    return moment(date).format('YYYY-MM-DD')
  }

  const formatIsoDatetime = (date) => {
    if (!date) return ''
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }

  const formatToISODateString = (date) => {
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')

    return `${day}/${month}/${year}`
  }

  const formatToMySQLDatetime = (date) => {
    if (!date) return null
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }

  const formatBrDateToIso = (date, hour = '00:00:00') => {
    const [day, month, year] = date.split('/')
    const formattedDate = `${year}-${month}-${day}T${hour}`

    return moment(formattedDate).format('YYYY-MM-DD HH:mm:ss') //new Date()
  }

  const formatRangeDate = (date) => {
    if (!date || !Array.isArray(date)) return null
    if (date.length == 0) return null
    if (date.length == 1) return formatDate(date[0])
    date.sort()
    if (date.length == 2) return `${formatDate(date[0])} à ${formatDate(date[1])}`
  }

  const formatDatetimeToTimezone = (date, timezone = 'America/Sao_Paulo') => {
    if (!date) return ''
    return moment.utc(date).tz(timezone).format('YYYY-MM-DD HH:mm:ss')
  }
  const formatConstructionStatus = (status) => {
    switch (status) {
      case 'open':
        return 'Aberto'
      case 'emergency':
        return 'Andamento Emergência'
      case 'in_progress':
        return 'Andamento'
      case 'done':
        return 'Concluída'
      case 'canceled':
        return 'Cancelada'
      case 'pending':
        return 'Pendente'
    }
  }
  const formatProtocol = (protocolNumber) => {
    if (!protocolNumber) {
      return ''
    }
    const year = protocolNumber.substring(0, 4)
    const month = protocolNumber.substring(4, 6)
    const day = protocolNumber.substring(6, 8)
    const hour = protocolNumber.substring(8, 10)
    const minute = protocolNumber.substring(10, 12)
    const remaining = protocolNumber.substring(12)

    return `${year}${month}${day}.${hour}${minute}.${remaining}`
  }

  const formatMos = (oldCode) => {
    if (!oldCode) return
    const code = `${oldCode.trim()}`
    if (!code) return
    if (code.length < 6) return code

    if (code.length == 6) {
      return `${code.slice(0, 2)}.${code.slice(2, 4)}.${code.slice(4, 6)}`
    }
    if (code.length == 9) {
      return `${code.slice(0, 3)}.${code.slice(3, 6)}.${code.slice(6, 9)}`
    }
    return code
  }

  const formatProgressText = (status) => {
    let text = status
    switch (status) {
      case 'PENDENTE DE CARGA NO EQUIPAMENTO':
        text = 'PENDENTE DE CARGA'
        break
      case 'AGUARDANDO EQUIPE CONFIRMAR RECEBIMENTO':
        text = 'AGUARDAR RECEBIMENTO'
        break
    }
    return text
  }

  const formatStatusText = (text) => {
    switch (text) {
      case 'EXPIRA EM 2 HORAS':
        return 'EXPIRA 2H'
      case 'EXPIRA EM 1 HORA':
        return 'EXPIRA 1H'
      default:
        return text
    }
  }

  const formatVehicleFuelType = (text) => {
    switch (text) {
      case 'alcohol':
        return 'Álcool'
      case 'diesel':
        return 'Diesel'
      case 'gasoline':
        return 'Gasolina'
      case 'flex':
        return 'Flex'
      default:
        return text
    }
  }

  const formatVehicleStatus = (text) => {
    switch (text) {
      case 'active':
        return 'Ativo'
      case 'inactive':
        return 'Inativo'
      case 'maintenance':
        return 'Em manutenção'
      case 'sold':
        return 'Vendido'
      default:
        return text
    }
  }

  const removeLeadingZeros = (str) => {
    if (!str && str !== 0) return ''
    return String(str)
      .trim()
      .replace(/^0+(?!$)/, '')
  }

  const formatCode = (id, length = 6) => {
    return String(id).padStart(length, '0')
  }

  const formatQuantity = (quantity, length = 2) => {
    if (!quantity) return '0'
    return quantity.toString().padStart(length, '0')
  }

  const formatStatus = (value) => {
    if (value === 1 || value === '1') return 'Ativo'
    if (value === 0 || value === '0') return 'Inativo'
    return value
  }

  const formatMosType = (value) => {
    if (value === 'external') return 'Externo'
    if (value === 'internal') return 'Interno'
    return value
  }

  const formatFilenameTimestamp = (date = new Date()) => {
    return moment(date).format('DD-MM-YYYY_HH-mm-ss')
  }

  return {
    formatMoney,
    formatNumber,
    formatMoneyS,
    formatDate,
    formatUtcDate,
    formatMonth,
    formatFullDate,
    formatFullDateGMT,
    formatIsoDate,
    formatIsoDatetime,
    formatToISODateString,
    formatBrDateToIso,
    formatRangeDate,
    formatProtocol,
    formatMos,
    formatProgressText,
    formatStatusText,
    formatVehicleStatus,
    formatVehicleFuelType,
    formatToMySQLDatetime,
    formatDatetimeToTimezone,
    removeLeadingZeros,
    formatCode,
    formatQuantity,
    formatStatus,
    formatMosType,
    formatConstructionStatus,
    formatFilenameTimestamp,
  }
}
